import { checkBeforeEnter } from '@/auth/utils';

export default [
	{
		path: '/usuarios',
		name: 'users-list',
		component: () => import('@/views/modules/users/users-list/UsersList.vue'),
		beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
		meta: {
			resource: 'ACL',
			pageTitle: 'Usuarios',
			breadcrumb: [{
				text: 'Lista de usuarios',
				active: true
			}],
			requiresAuth: true
		}
	},
	{
		path: '/usuarios/nuevo',
		name: 'users-create',
		component: () => import ('@/views/modules/users/users-store/UsersStore.vue'),
		beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
		meta: {
			resource: 'ACL',
			pageTitle: 'Usuarios',
			breadcrumb: [{
				text: 'Lista de usuarios',
				to: { name: 'users-list' },
			},{
				text: 'Nuevo usuario',
				active: true
			}],
			requiresAuth: true
		}
	},
    {
        path: '/usuarios/:id/editar',
        name: 'users-edit',
        component: () => import ('@/views/modules/users/users-edit/UsersEdit.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Usuarios',
            breadcrumb: [{
				text: 'Lista de usuarios',
				to: { name: 'users-list' },
			}, {
                text: 'Editar usuario',
                active: true
            }],
            requiresAuth: true
        }
    }
]